import { Component, inject } from '@angular/core';
import { formControl, Validators } from '@al00x/forms';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFormBuilderComponent,
  CacImageUploaderComponent,
  formBuilder,
} from '@controladad/ng-base';
import { TagCreate, TagEntity, TagUpdate } from '@repo/types';
import { TagApiService } from '@/core';

export interface TagDialogData {
  tag?: TagEntity;
}

export type TagDialogResult = boolean;

@Component({
  selector: 'app-tag-dialog',
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent],
  templateUrl: './tag-dialog.component.html',
  styleUrl: './tag-dialog.component.scss',
})
export class TagDialogComponent extends CacBaseDialogComponent<TagDialogData, TagDialogResult> {
  private readonly tagApi = inject(TagApiService);

  form = formBuilder({
    cols: 1,
    inputs: {
      name: {
        control: formControl<string>(undefined, Validators.required),
        label: 'Title',
      },
    },
  });

  constructor() {
    super();
    const values = this.data?.tag;
    if (values) {
      this.form.patchValue(values);
    }
  }

  onSubmit(e: ButtonClickEvent) {
    const values = this.form.getValue();

    if (!values) return;
    const request = this.data?.tag
      ? this.tagApi.updateTag({
          type: { value: this.data.tag.type },
          name: { value: values.name },
          id: this.data.tag.id,
        })
      : this.tagApi.create({ name: values.name, type: 0 });
    request.pipe(e.pipe()).subscribe(() => {
      this.submit(true);
    });
  }
}
